import React from "react";

import { MenuIds, useMenus } from "../../../hooks/useMenus";
import { useLabels } from "../../../hooks/useLabels";
import { useAppContext } from "../../../hooks/useAppContext";
import { useProductStartDate } from "../../../hooks/useProductStartDate";
import { useProductStartDates } from "../../../hooks/useProductStartDates";
import { useErrorHandling } from "../../../hooks/useErrorHandling";
import { labels } from "../../bottom-menus/options/labels";
import { SidebarPanel } from "../sidebar-panel";
import { SidebarOptions } from "./sidebar-options-list";
import { Icon } from "../../icon";

interface ISidebarStartDateProps {
	supportedStartDate: "year" | "month";
}

export function SidebarStartDate({ supportedStartDate }: ISidebarStartDateProps) {
	const {
		menuId,
		actions: { setMenu },
	} = useMenus();
	const { createErrorHandler } = useErrorHandling();
	const {
		context: { language },
	} = useAppContext();
	const [[startDateText]] = useLabels([
		supportedStartDate === "year" ? labels.startYear : labels.startMonth,
	]);
	const [startDates, changeStartDate] = useProductStartDates();
	const selectedStartDate = useProductStartDate();

	return (
		<>
			<SidebarPanel.SubTitle icon={<Icon iconName="calendar" />}>
				{startDateText}
			</SidebarPanel.SubTitle>
			<SidebarOptions.List type="list">
				{startDates.map((startDate) => {
					const isActive = selectedStartDate === startDate;
					const months = eXpress.getLocalizedMonthNames(language);
					const jsStartDate = eXpress.DateMonthString.toDate(startDate);
					const dateString =
						supportedStartDate === "year"
							? `${jsStartDate.getFullYear()}`
							: `${months[jsStartDate.getMonth()]} ${jsStartDate.getFullYear()}`;

					return (
						<SidebarOptions.Item
							type="list"
							key={startDate}
							title={dateString}
							isActive={isActive}
							onClick={() => {
								// Mark DateSelection as active menu
								if (menuId !== MenuIds.DateSelection) {
									setMenu(MenuIds.DateSelection);
								}

								changeStartDate?.(startDate).catch(createErrorHandler());
							}}
						/>
					);
				})}
			</SidebarOptions.List>
		</>
	);
}
